export default function Marquee({ items, dark = false, slow = false, className = "" }) {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`whitespace-nowrap px-6 text-sm font-semibold uppercase tracking-[0.3em] md:px-10 ${dark ? "text-white/80" : "text-navy/80"}`}>
            {item}
          </span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-brand" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden border-y py-5 md:py-6 ${dark ? "border-white/10 bg-navy-obsidian" : "border-hairline bg-mist"} ${className}`}>
      <div className={`flex w-max ${slow ? "animate-marqueeSlow" : "animate-marquee"}`}>
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
